






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class DownloadIcon extends Vue {
  @Prop({ default: '24px' }) public size!: string;
}
